import React from 'react';
import { logoMarqueeItems } from './LogoMarqueeConstants';
import './LogoMarquee.scss';

const LogoMarquee: React.FC = () => {
  // Keep each animated segment wider than the viewport so the loop never reveals a gap.
  const marqueeSegment = [...logoMarqueeItems, ...logoMarqueeItems];

  return (
    <section className="logo-marquee" aria-label="Featured companies">
      <div className="logo-marquee-track">
        {[0, 1].map((segmentIndex) => (
          <div
            key={segmentIndex}
            className="logo-marquee-inner"
            aria-hidden={segmentIndex === 1}
          >
            {marqueeSegment.map((item, index) => (
              <div key={`${segmentIndex}-${item.name}-${index}`} className="logo-marquee-item">
                <img
                  src={item.src}
                  alt={segmentIndex === 0 ? item.name : ''}
                  className="logo-marquee-img"
                  loading="eager"
                  onError={(e) => {
                    (e.target as HTMLImageElement).style.display = 'none';
                    const fallback = document.createElement('span');
                    fallback.className = 'logo-marquee-fallback';
                    fallback.textContent = item.name;
                    (e.target as HTMLImageElement).parentNode?.appendChild(fallback);
                  }}
                />
              </div>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
};

export default LogoMarquee;
